
import React from 'react';
import { TimesManager } from '@/components/admin/TimesManager';
import { useLanguage } from '@/contexts/LanguageContext';

const TimesManagerPage: React.FC = () => {
  const { direction } = useLanguage();
  const isRtl = direction === 'rtl';

  return (
    <div className="container mx-auto py-8">
      <h1 className={`text-2xl font-bold mb-8 ${isRtl ? 'text-right' : 'text-left'}`}>
        {isRtl ? 'ניהול זמנים' : 'Times Management'}
      </h1>
      
      <TimesManager />
    </div>
  );
};

export default TimesManagerPage;
